export default "__VITE_ASSET__275890fb__"